import { appComponentDirectory } from '@utils/appComponentDirectory';
import ErrorBoundary from '@repo/ui/src/components/ErrorBoundary';

// loop component directory to find component will need second function to breakdown each AMP schema
const getComponents = (ampData) => {
  const key = Object.keys(appComponentDirectory).find((schema) => ampData.schema === schema);
  if (key !== undefined) {
    const RenderedComponent = appComponentDirectory[key];
    if (!RenderedComponent) return null;
    return (
      <ErrorBoundary key={ampData.id}>
        <RenderedComponent _testID={ampData.id} {...ampData.props} />
      </ErrorBoundary>
    );
  }
  console.warn(`Component: ${ampData.schema} does not exist in registry.`);
  return <div key={ampData.id} className="schemaDoesNotExist tw-hidden" />;
};

export default getComponents;
